import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "hint-time"
};
const _hoisted_3 = {
  key: 0,
  class: "obsolete"
};
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = ["onClick"];
const _hoisted_6 = {
  key: 1,
  id: "unlocks"
};
const _hoisted_7 = ["title"];
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = {
  key: 0,
  class: "obsolete"
};
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "hint-time"
};
const _hoisted_13 = {
  key: 0,
  class: "unlock-divider"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", null, [_cache[4] || (_cache[4] = _createElementVNode("h3", null, "Clues", -1 /* CACHED */)), $options.none ? (_openBlock(), _createElementBlock("p", _hoisted_1, [...(_cache[0] || (_cache[0] = [_createElementVNode("em", null, "None yet", -1 /* CACHED */)]))])) : _createCommentVNode("v-if", true), _createVNode(_TransitionGroup, {
    id: "hints",
    name: "highlight",
    tag: "ul"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.sortedHints, ([id, hint]) => {
      return _openBlock(), _createElementBlock("li", {
        key: id,
        class: _normalizeClass(hint.isNew ? 'newClue' : 'oldClue')
      }, [_createElementVNode("span", _hoisted_2, _toDisplayString($options.durationString(hint.time)) + ": ", 1 /* TEXT */), hint.obsolete ? (_openBlock(), _createElementBlock("span", _hoisted_3, [...(_cache[1] || (_cache[1] = [_createTextVNode(" (", -1 /* CACHED */), _createElementVNode("span", {
        class: "hover",
        title: "You entered a guess which indicated you don't need this hint"
      }, "surpassed", -1 /* CACHED */), _createTextVNode(") ", -1 /* CACHED */)]))])) : _createCommentVNode("v-if", true), _createCommentVNode(" eslint-disable vue/no-v-html -- Hint text is admin generated content "), hint.accepted ? (_openBlock(), _createElementBlock("strong", {
        key: 1,
        class: _normalizeClass({
          obsolete: hint.obsolete
        }),
        innerHTML: hint.hint
      }, null, 10 /* CLASS, PROPS */, _hoisted_4)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_createCommentVNode(" eslint-enable vue/no-v-html "), _createElementVNode("a", {
        href: "#",
        class: _normalizeClass({
          obsolete: hint.obsolete
        }),
        onClick: _withModifiers($event => $options.acceptHint(id, null), ["prevent"])
      }, "show", 10 /* CLASS, PROPS */, _hoisted_5)], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))], 2 /* CLASS */);
    }), 128 /* KEYED_FRAGMENT */))]),
    _: 1 /* STABLE */
  }), $props.clueData.unlocks.size > 0 ? (_openBlock(), _createElementBlock("table", _hoisted_6, [_cache[3] || (_cache[3] = _createElementVNode("thead", null, [_createElementVNode("tr", {
    class: "unlock"
  }, [_createElementVNode("th", {
    class: "unlock-guesses"
  }, " Guesses "), _createElementVNode("th", {
    class: "unlock-clues"
  }, " Clues ")])], -1 /* CACHED */)), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.sortedUnlocks, ([id, unlock], index) => {
    return _openBlock(), _createElementBlock("tr", {
      key: id,
      class: "unlock"
    }, [_createElementVNode("td", null, [_createVNode(_TransitionGroup, {
      id: `unlock-${id}-guesses`,
      name: "highlight",
      tag: "ul",
      class: "unlock-guesses",
      appear: ""
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unlock.guesses, ua => {
        return _openBlock(), _createElementBlock("li", {
          key: ua,
          title: ua,
          class: _normalizeClass(unlock.isNew ? 'newClue' : 'oldClue')
        }, [_createElementVNode("strong", null, _toDisplayString(ua), 1 /* TEXT */)], 10 /* CLASS, PROPS */, _hoisted_7);
      }), 128 /* KEYED_FRAGMENT */))]),
      _: 2 /* DYNAMIC */
    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id"])]), _createElementVNode("td", null, [_createVNode(_TransitionGroup, {
      id: `unlock-${id}-hints`,
      name: "highlight",
      tag: "ul",
      class: "unlock-clues",
      appear: ""
    }, {
      default: _withCtx(() => [_createCommentVNode(" eslint-disable vue/no-v-html -- Unlock text is admin generated content "), unlock.unlock ? (_openBlock(), _createElementBlock("li", {
        key: 0,
        class: "unlock-text",
        innerHTML: unlock.unlock
      }, null, 8 /* PROPS */, _hoisted_8)) : _createCommentVNode("v-if", true), _createCommentVNode(" eslint-enable vue/no-v-html "), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unlock.hints, ([hintID, hint]) => {
        return _openBlock(), _createElementBlock("li", {
          key: hintID,
          class: _normalizeClass(hint.isNew ? 'newClue' : 'oldClue')
        }, [hint.obsolete ? (_openBlock(), _createElementBlock("span", _hoisted_9, [...(_cache[2] || (_cache[2] = [_createTextVNode(" (", -1 /* CACHED */), _createElementVNode("span", {
          class: "hover",
          title: "You entered a guess which indicated you don't need this hint"
        }, "surpassed", -1 /* CACHED */), _createTextVNode(") ", -1 /* CACHED */)]))])) : _createCommentVNode("v-if", true), _createCommentVNode(" eslint-disable vue/no-v-html -- Hint text is admin generated content "), hint.accepted ? (_openBlock(), _createElementBlock("strong", {
          key: 1,
          class: _normalizeClass({
            obsolete: hint.obsolete
          }),
          innerHTML: hint.hint
        }, null, 10 /* CLASS, PROPS */, _hoisted_10)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 2
        }, [_createCommentVNode(" eslint-enable vue/no-v-html "), _createElementVNode("a", {
          href: "#",
          onClick: _withModifiers($event => $options.acceptHint(hintID, id), ["prevent"])
        }, "show", 8 /* PROPS */, _hoisted_11)], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */)), _createElementVNode("span", _hoisted_12, " (after " + _toDisplayString($options.durationString(hint.time)) + ")", 1 /* TEXT */)], 2 /* CLASS */);
      }), 128 /* KEYED_FRAGMENT */))]),
      _: 2 /* DYNAMIC */
    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id"])]), index != $options.sortedUnlocks.length - 1 ? (_openBlock(), _createElementBlock("div", _hoisted_13)) : _createCommentVNode("v-if", true)]);
  }), 128 /* KEYED_FRAGMENT */))])])) : _createCommentVNode("v-if", true)]);
}